document.addEventListener("DOMContentLoaded", function () {
    const interval = setInterval(() => {
        const bcpButtons = document.querySelectorAll(".bss-b2b-customer-portal-nt-checkout-btn");
        if (!bcpButtons.length) return;
        clearInterval(interval);
        bcpButtons.forEach((button) => button.removeAttribute("name"));
    }, 100);
    setTimeout(() => clearInterval(interval), 5000);
});